import React, { useEffect } from "react";
import { setNavigate } from "../../../util/navigationService";
import { useNavigate } from 'react-router-dom'

function NavigationHandler() {
    const navigate = useNavigate();

    useEffect(() => {
        setNavigate(navigate)
    }, [navigate])

    return null;
}

export default NavigationHandler;